import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  LinearProgress,
  Stack,
  TextField,
  MenuItem,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";

function EditVideoDialog({
  open,
  onClose,
  saving,
  editTarget,
  editValues,
  setEditValues,
  editAudioUploading,
  editAudioProgress,
  onSave,
}) {
  return (
    <Dialog
      open={open}
      onClose={() => (saving ? null : onClose)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        Edit {editTarget?._kind === "audio" ? "Audio" : "Video"}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Title"
            value={editValues.title}
            onChange={(e) =>
              setEditValues((v) => ({ ...v, title: e.target.value }))
            }
            fullWidth
          />
          <TextField
            select
            label="Category"
            value={editValues.category}
            onChange={(e) =>
              setEditValues((v) => ({ ...v, category: e.target.value }))
            }
            fullWidth
          >
            <MenuItem value="meditation">meditation</MenuItem>
            <MenuItem value="reflection">reflection</MenuItem>
            <MenuItem value="meditation_retreat_day1">
              meditation_retreat_day1
            </MenuItem>
            <MenuItem value="meditation_retreat_day2">
              meditation_retreat_day2
            </MenuItem>
            <MenuItem value="meditation_retreat_day3">
              meditation_retreat_day3
            </MenuItem>
            <MenuItem value="simply_still_anger">simply_still_anger</MenuItem>
            <MenuItem value="simply_still_anxiety">simply_still_anxiety</MenuItem>
            <MenuItem value="simply_still_grounding">
              simply_still_grounding
            </MenuItem>
            <MenuItem value="simply_still_morning">simply_still_morning</MenuItem>
            <MenuItem value="simply_still_sadness">simply_still_sadness</MenuItem>
            <MenuItem value="simply_still_sleep">simply_still_sleep</MenuItem>
            <MenuItem value="simply_still_stress">simply_still_stress</MenuItem>
          </TextField>
          {editTarget?._kind === "video" ? (
            <TextField
              label="YouTube URL"
              value={editValues.url}
              onChange={(e) =>
                setEditValues((v) => ({ ...v, url: e.target.value }))
              }
              fullWidth
            />
          ) : (
            <>
              <TextField
                label="Description"
                value={editValues.description}
                onChange={(e) =>
                  setEditValues((v) => ({
                    ...v,
                    description: e.target.value,
                  }))
                }
                fullWidth
                multiline
                minRows={2}
              />
              <Box>
                <Typography variant="caption" sx={{ color: "#64748b" }}>
                  Replace audio file (optional)
                </Typography>
                <input
                  type="file"
                  accept="audio/*"
                  onChange={(e) =>
                    setEditValues((v) => ({
                      ...v,
                      file: e.target.files?.[0] || null,
                    }))
                  }
                />
              </Box>
            </>
          )}
          {editAudioUploading && (
            <Box sx={{ mt: 1 }}>
              <LinearProgress variant="determinate" value={editAudioProgress} />
              <Typography variant="caption" sx={{ color: "#64748b" }}>
                {Math.round(editAudioProgress)}%
              </Typography>
            </Box>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button variant="contained" disabled={saving} onClick={onSave}>
          {saving ? (
            <CircularProgress size={18} sx={{ color: "#fff" }} />
          ) : (
            "Save"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditVideoDialog;
